<template>
    <table class="table table-striped detail-table">
        <tbody>

        <template v-if="isEmpty(doctor)">
            <tr v-for="(row, index) in doctor" :key="index">
                <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                <td>{{row}}</td>
            </tr>
        </template>
        <template v-else>
            <tr>
                <td colspan="2">No records found.</td>
            </tr>
        </template>

        </tbody>
    </table>
</template>

<script>
  export default {
    props: {
      doctor: {
        type: Object,
        default: {}
      }
    },

    data() {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Doctor/DetailTable.vue